// extracted by mini-css-extract-plugin
export default {"nav__item":"header-nav-item_nav__item__MGMgH","nav__item__active":"header-nav-item_nav__item__active__xvxbk"};